import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/InstructorFormativeJourney/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Stack, styled, Text } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const FormativeJourneySummaryCard = () => {
    const { studentAccountUsers } = useApp();
    const { device } = useViewport();
    const { t } = useTranslation('assignment');

    const { currentStudentSubmissions } = useContext(PageContext);

    const latestStudentSubmission = currentStudentSubmissions.slice(-1)[0];
    const studentName = getUserPreferredFullName(
        studentAccountUsers.find(
            ({ owner_account_id }) => owner_account_id === latestStudentSubmission.owner_account_id
        )
    );

    return (
        <CustomPaper device={device}>
            <Stack spacing={3}>
                <Text weight={'medium'}>
                    {t('formative-feedback.learning-process-title', '{{studentName}}’s Learning Process 📌', {
                        studentName,
                    })}
                </Text>
                <Text>{latestStudentSubmission.ai.ai_learning_summary}</Text>
            </Stack>
        </CustomPaper>
    );
};

const CustomPaper = styled(Paper)(({ theme, device }) => {
    return {
        maxWidth: '500px',
        height: 'fit-content',
        padding: theme.spacing(3),
        ...(device !== 'mobile' && {
            alignSelf: 'end',
        }),
    };
});

export default FormativeJourneySummaryCard;
